import React, { useEffect, useRef, useState } from "react";
import moment from "jalali-moment";
import clsx from "clsx";

import MicIcon from "../../../../../images/demo/main_section/mic_svg";
import LinkIcon from "../../../../../images/demo/main_section/link_svg";
import ResponseNew from "../../../../Demo/ResponseNew";
import { AttachIcon } from "../../../../../images";
import { toFarsiNumber } from "../../../../Archive/utils";
import { time_to_second } from "../../../../Demo/utils/functions";
import {
  deleteRequest,
  getRequestFromId,
  patchRequest,
} from "../../../../Archive/data";
import EditIcon from "../../../../icons/edit-icon";
import DeleteIcon from "../../../../icons/delete-icon";
import CloseIcon from "../../../../icons/close-icon";
import TickIcon from "../../../../icons/tick-icon";
import { useDispatch } from "react-redux";
import { removeSearchResult } from "../../../../../services/state/search";
import { toast } from "react-toastify";
import { errorNotify, successNotify } from "../../../../notify/toastify";

const iconType = {
  Url: {
    icon: <LinkIcon />,
    color: "#FF1654",
  },
  Voice: {
    icon: <MicIcon />,
    color: "#40c6b8",
  },
  File: {
    icon: <AttachIcon />,
    color: "#118AD3",
  },
};

const ListViewItem = ({ item }) => {
  const type = "Url";
  const date = new Date(item.processed);
  const url = item.media_url;

  const formattedDateDay = moment(date).locale("fa").format("DD");
  const formattedDateMonth = moment(date).locale("fa").format("MMMM");
  const formattedDateYear = moment(date).locale("fa").format("YYYY");

  // const fileName = item.segment.text;
  const segments = item.segments;
  const [loadingResults, setLoadingResults] = useState(false);
  const [finalResponse, setFinalResponse] = useState(null);
  const [loadImage, setLoadImage] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const fileExtension = url.split(".").pop();
  const fileName =
    item.filename === `.${fileExtension}` ||
    item.filename === "" ||
    item.filename == null ||
    item.filename == undefined
      ? url.split("/").pop()
      : item.filename.split(".").slice(0, -1).join(".");
  const [fileEdit, setFileEdit] = useState(fileName);
  const dialogRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const clickHandle = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        closeModal();
        setFinalResponse(null);
      }
    };
    document.addEventListener("mousedown", clickHandle);
    return () => {
      document.removeEventListener("mousedown", clickHandle);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = async () => {
    if (!isEdit && !isDelete) {
      setIsOpen(true);
      setLoadingResults(true);
      const response = await getRequestFromId({ id: item.id });

      if (response) {
        setFinalResponse({
          ...response,
          duration: time_to_second(response.duration),
          segmentId: item.segments[0].segment_id,
        });
      }
      setLoadingResults(false);
    }
  };

  const RemoveEmTagsAndBold = (text) => {
    // Regular expression to find text between <em> tags
    const regex = /<em>(.*?)<\/em>/g;

    // Replace <em> tags with the found text wrapped in <strong> tags
    const updatedText = text.replace(
      regex,
      (_, group) =>
        `<strong style="color:#727272; font-family:iranyekan-bold">${group}</strong>`
    );

    return <div dangerouslySetInnerHTML={{ __html: updatedText }} />;
  };

  const openEdit = (e) => {
    e.stopPropagation();
    setIsEdit(true);
  };

  const closeEdit = () => {
    setIsEdit(false);
    setFileEdit(fileName);
  };

  const changeFilename = (e) => {
    setFileEdit(e.target.value);
  };

  const openDelete = (e) => {
    e.stopPropagation();
    setIsDelete(true);
  };

  const closeDelete = () => {
    setIsDelete(false);
  };

  const handleDelete = async () => {
    try {
      await deleteRequest({ id: item.id });
      dispatch(removeSearchResult(item.id));
      setIsDelete(false);
      successNotify({ text: "با موفقیت حذف شد" });
    } catch (error) {
      errorNotify({ text: "مشکلی پیش آمده" });
    }
  };

  const handleEdit = async () => {
    try {
      await patchRequest({
        id: item.id,
        filename: fileEdit,
        prefix: fileExtension,
      });
      setIsEdit(false);
      successNotify({ text: "با موفقیت ویرایش شد" });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      window.location.reload();
    } catch (error) {
      errorNotify({ text: "مشکلی پیش آمده" });
    }
  };

  return (
    <>
      <div
        className="list-view-item"
        onClick={openModal}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="list-view-image-title">
          {!loadImage && (
            <div className="tbc justify-center" style={{ width: "50px" }}>
              <button className="unstyled-btn"></button>
              <div
                className="icon-wrapper"
                style={
                  iconType[type] && {
                    "--color": iconType[type].color,
                  }
                }
              >
                {iconType[type] ? iconType[type].icon : iconType["Voice"].icon}
              </div>
            </div>
          )}
          <div
            className="list-view-thumbnail-container"
            style={
              loadImage && !imageError
                ? { display: "flex" }
                : { display: "none" }
            }
          >
            <img
              alt=""
              src={`/media_image/${url}`}
              width={64}
              height={64}
              onLoad={() => setLoadImage(true)}
              onError={() => setImageError(true)}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "10px",
              }}
            />
          </div>
          {!isEdit ? (
            <>
              <div
                className="list-view-item-title"
                style={{ direction: "rtl", maxWidth: "363px" }}
              >
                {item.filename == null ? url : fileName}
              </div>
              <div className="title-information">
                <div className="list-view-item-date">
                  <span>{formattedDateDay}</span>
                  <span>{formattedDateMonth}</span>
                  <span>{formattedDateYear}</span>
                </div>
                <span className="list-view-item-duration">
                  {toFarsiNumber(item.duration)}
                </span>
              </div>
            </>
          ) : (
            <input
              className="edit-input"
              type="text"
              onChange={(e) => changeFilename(e)}
              value={fileEdit}
              style={{ textOverflow: "ellipsis" }}
            ></input>
          )}
        </div>
        {segments.map((item, index) => {
          return index < 3 ? (
            <div key={index} style={{ width: "100%", paddingRight: "84px" }}>
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  width: "auto",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  textWrap: "nowrap",
                  direction: "rtl",
                  alignItems: "center",
                  minWidth: "450px",
                }}
              >
                <span className="list-view-item-duration">
                  {toFarsiNumber(item.segment.start)}
                </span>
                <div
                  dir="rtl"
                  style={{
                    marginRight: "8px",
                    color: "#727272",
                    fontSize: "16px",
                    fontFamily: "iranyekan-light",
                  }}
                >
                  {RemoveEmTagsAndBold(item.segment.text)}
                </div>
                {segments[0] === item && (
                  <>
                    {!isEdit && (
                      <div className="list-view-tools">
                        <EditIcon
                          width={16}
                          height={16}
                          style={{ cursor: "pointer", marginLeft: "1rem" }}
                          onClick={(e) => openEdit(e)}
                        />
                        <DeleteIcon
                          width={16}
                          height={16}
                          color="#8F8F8F"
                          onClick={(e) => openDelete(e)}
                        />
                      </div>
                    )}
                    {isEdit && (
                      <div className="list-view-tools">
                        <TickIcon
                          width={14}
                          height={14}
                          style={{
                            cursor: "pointer",
                            marginLeft: "1rem",
                          }}
                          onClick={handleEdit}
                        />
                        <CloseIcon
                          height={14}
                          width={14}
                          color={"#939393"}
                          style={{ cursor: "pointer" }}
                          onClick={closeEdit}
                        />
                      </div>
                    )}
                    {isDelete && !isEdit && (
                      <div className="list-view-tools" style={{ left: "0%" }}>
                        <button
                          className="list-view-button"
                          style={{
                            color: "#FFFFFF",
                            backgroundColor: "#E23D28",
                          }}
                          onClick={handleDelete}
                        >
                          حذف
                        </button>
                        <button
                          className="list-view-button"
                          style={{
                            backgroundColor: "#FFFFFF",
                            color: "#727272",
                          }}
                          onClick={closeDelete}
                        >
                          لغو
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ) : (
            <div></div>
          );
        })}
        {segments.length > 3 ? (
          <div style={{ width: "100%", paddingRight: "84px" }}>
            <div
              style={{
                display: "flex",
                position: "relative",
                width: "auto",
                textOverflow: "ellipsis",
                overflow: "hidden",
                textWrap: "nowrap",
                direction: "rtl",
                alignItems: "center",
              }}
            >
              <span
                className="list-view-item-duration"
                style={{ fontFamily: "iranyekan-bold" }}
              >
                و {toFarsiNumber(segments.length - 3)}
              </span>
              <div
                dir="rtl"
                style={{
                  marginRight: "8px",
                  color: "#727272",
                  fontSize: "16px",
                  fontFamily: "iranyekan-light",
                }}
              >
                مورد دیگر
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className={clsx("modal", isOpen ? "modal-enter" : "modal-leave")}>
        <div
          className={clsx("dialog", isOpen ? "dialog-enter" : "dialog-leave")}
          dir="ltr"
          ref={dialogRef}
        >
          {finalResponse && (
            <ResponseNew finalResponse={finalResponse} isArchive={true} />
          )}
          {loadingResults && (
            <div className="response-new no-padding">
              <div className="atom-spinner">
                <div className="spinner-inner">
                  <div className="spinner-line"></div>
                  <div className="spinner-line"></div>
                  <div className="spinner-line"></div>
                  <div className="spinner-circle">&#9679;</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ListViewItem;
